// =============================================================================
// LISTE DES BANQUES POUR LE DROPDOWN FRONTEND
// Les valeurs affichées sont les libellés April
// Les valeurs envoyées au backend sont les codes April (APRIL_CODE)
// =============================================================================

export const BANQUES_LIST = [
  // --- Banque inconnue ---
  { label: 'Banque inconnue / Autre', value: 'inconnu' },

  // --- A ---
  { label: 'Action Logement Services', value: 'Action_Logement_Services' },
  { label: 'Allianz Banque', value: 'Allianz_Banque' },
  { label: 'AXA Banque', value: 'axa_banque' },

  // --- B ---
  { label: 'Banque BCP', value: 'Banque_BCP' },
  { label: 'Banque Chalus', value: 'Banque_Chalus' },
  { label: 'Banque de France', value: 'Banque_de_France' },
  { label: 'Banque de la Réunion', value: 'Banque_de_la_Reunion' },
  { label: 'Banque de Savoie', value: 'Banque_de_Savoie' },
  { label: 'Banque Dupuy de Parseval', value: 'Banque_Dupuy_De_Parseval' },
  { label: 'Banque Européenne du Crédit Mutuel', value: 'banque_europ_credit_mut' },
  { label: 'Banque Française Commerciale Océan Indien', value: 'Banque_Commerciale_Ocean_Indien' },
  { label: 'Banque Française Mutualiste contrat 7371 M', value: 'Banque_Mutualiste_7371_M' },
  { label: 'Banque Française Mutualiste contrat 7372 N', value: 'Banque_Mutualiste_7372_N' },
  { label: 'Banque Marze', value: 'Banque_Marze' },
  { label: 'Banque Palatine', value: 'BQ_PALATINE' },
  { label: 'Banque Transatlantique', value: 'Banque_transatlantique' },

  // --- Banques Populaires ---
  { label: 'Banque Populaire Alsace Lorraine et Champagne', value: 'banque_pop_alsace_lorraine_champagne' },
  { label: 'Banque Populaire Aquitaine Centre Atlantique', value: 'banque_pop_Aquitaine_centre_Atlantique' },
  { label: 'Banque Populaire AURA', value: 'banque_pop_AURA' },
  { label: 'Banque Populaire Bourgogne Franche-Comté', value: 'banque_pop_bourgogne_franche_comte' },
  { label: 'Banque Populaire du Nord', value: 'banque_pop_Du_nord' },
  { label: 'Banque Populaire du Sud', value: 'banque_pop_SUD' },
  { label: 'Banque Populaire Grand Ouest', value: 'banque_pop_GRAND_OUEST' },
  { label: 'Banque Populaire Méditerranée', value: 'banque_pop_mediterranee' },
  { label: 'Banque Populaire Occitane', value: 'banque_pop_OCCITANE' },
  { label: 'Banque Populaire Rives de Paris', value: 'banque_pop_RIVES_DE_PARIS' },
  { label: 'Banque Populaire Val de France', value: 'banque_pop_VAL_DE_France' },

  // --- BforBank ---
  { label: 'BforBank', value: 'BFORBANK' },

  // --- BNP ---
  { label: 'BNP PARIBAS', value: 'BNP' },
  { label: 'BNP PARIBAS Antilles Guyane', value: 'BNP_PARIBAS_Antilles_Guyane' },
  { label: 'BNP PARIBAS Lease Group', value: 'BNP_Paribas_Lease_Groupe' },
  { label: 'BNP PARIBAS Personal Finance', value: 'BNP_Paribas_Personal_Finance' },
  { label: 'BNP PARIBAS Réunion', value: 'BNP_PARIBAS_Reunion' },

  // --- Boursorama ---
  { label: 'Boursorama Banque', value: 'boursorama' },

  // --- BPCE ---
  { label: 'BPCE Financement', value: 'BPCE_Financement' },
  { label: 'BPCE Lease', value: 'BPCE_Lease' },
  { label: 'BPCE Lease Guadeloupe', value: 'BPCE_Lease_Guadeloupe' },
  { label: 'BPCE Lease Réunion', value: 'BPCE_Lease_Reunion' },

  // --- BPI ---
  { label: 'BPI Annecy', value: 'BPI_Annecy' },
  { label: 'BPI Avignon', value: 'BPI_Avignon' },
  { label: 'BPI Besançon', value: 'BPI_Besancon' },
  { label: 'BPI Brest', value: 'BPI_Brest' },
  { label: 'BPI Compiègne', value: 'BPI_Compiegne' },
  { label: 'BPI France', value: 'bpi_france' },
  { label: 'BPI La Roche sur Yon', value: 'BPI_La_Roche_Sur_Yon' },
  { label: 'BPI La Rochelle', value: 'BPI_La_Rochelle' },
  { label: 'BPI Le Mans', value: 'BPI_Le_Mans' },
  { label: 'BPI Limoges', value: 'BPI_Limoges' },
  { label: 'BPI Lorient', value: 'BPI_Lorient' },
  { label: 'BPI Metz', value: 'BPI_Metz' },
  { label: 'BPI Nice', value: 'BPI_Nice' },
  { label: 'BPI Nouvelle-Calédonie', value: 'BPI_Nouvelle-Caledonie' },
  { label: 'BPI Pau', value: 'BPI_Pau' },
  { label: 'BPI Perpignan', value: 'BPI_Perpignan' },
  { label: 'BPI Polynésie Française', value: 'BPI_Polynesie_Francaise' },
  { label: 'BPI Saint-Barthélémy', value: 'BPI_St-Barthelemy' },
  { label: 'BPI Saint-Brieuc', value: 'BPI_St-Brieuc' },
  { label: 'BPI Saint-Etienne', value: 'BPI_St-Etienne' },
  { label: 'BPI Saint-Martin', value: 'BPI_St-Martin' },
  { label: 'BPI Saint-Pierre-et-Miquelon', value: 'BPI_St-Pierre-et-Miquelon' },
  { label: 'BPI Tours', value: 'BPI_Tours' },
  { label: 'BPI Troyes', value: 'BPI_Troyes' },
  { label: 'BPI Valence', value: 'BPI_Valence' },
  { label: 'BPI Wallis et Futuna', value: 'BPI_Wallis_et_Futuna' },

  // --- BRED ---
  { label: 'BRED', value: 'BRED' },
  { label: 'BRED Cofilease', value: 'BRED_Cofilease' },

  // --- BTP ---
  { label: 'BTP Banque', value: 'btp_banque' },

  // --- C (divers) ---
  { label: 'CACIMA Saint-Pierre-et-Miquelon', value: 'Cacima_St-Pierre-et-Miquelon' },

  // --- Caisses d'Epargne ---
  { label: "Caisse d'Epargne Aquitaine Poitou Charentes", value: 'Caisse_Epargne_Aquitaine' },
  { label: "Caisse d'Epargne Bourgogne Franche-Comté", value: 'Caisse_Epargne_Bourgogne' },
  { label: "Caisse d'Epargne Bretagne Pays de la Loire", value: 'Caisse_Epargne_Bretagne' },
  { label: "Caisse d'Epargne CEPAC", value: 'Caisse_Epargne_CEPAC' },
  { label: "Caisse d'Epargne Côte d'Azur", value: 'Caisse_Epargne_Cote_Azur' },
  { label: "Caisse d'Epargne d'Auvergne et Limousin", value: 'Caisse_Epargne_Auvergne' },
  { label: "Caisse d'Epargne Grand Est Europe", value: 'Caisse_Epargne_Grand_Est' },
  { label: "Caisse d'Epargne Hauts de France", value: 'Caisse_Epargne_Hauts_de_France' },
  { label: "Caisse d'Epargne Ile-de-France", value: 'Caisse_Epargne_Ile_de_France' },
  { label: "Caisse d'Epargne Languedoc Roussillon", value: 'Caisse_Epargne_Languedoc' },
  { label: "Caisse d'Epargne Loire Centre", value: 'Caisse_Epargne_Loire_Centre' },
  { label: "Caisse d'Epargne Loire Drôme Ardèche", value: 'Caisse_Epargne_Loire_Drome' },
  { label: "Caisse d'Epargne Midi Pyrénées", value: 'Caisse_Epargne_Midi_Pyrenees' },
  { label: "Caisse d'Epargne Normandie", value: 'Caisse_Epargne_Normandie' },
  { label: "Caisse d'Epargne Rhône-Alpes", value: 'Caisse_Epargne_Rhone_Alpes' },

  // --- Caixa ---
  { label: 'Caixa Geral de Depositos', value: 'caixa_geral_depositos' },

  // --- CASDEN ---
  { label: 'CASDEN Banque Populaire', value: 'banque_pop_CASDEN' },

  // --- CCF ---
  { label: 'CCF', value: 'CCF' },

  // --- CCI ---
  { label: 'CCI Ain', value: 'CCI_Ain' },
  { label: 'CCI Aisne', value: 'CCI_Aisne' },
  { label: 'CCI Ajaccio et Corse du Sud', value: 'CCI_Ajaccio' },
  { label: 'CCI Alençon', value: 'CCI_Alencon' },
  { label: 'CCI Alès Cévennes', value: 'CCI_Ales_Cevennes' },
  { label: 'CCI Allier', value: 'CCI_Allier' },
  { label: 'CCI Alsace Eurométropole', value: 'CCI_Alsace_Eurometropole' },
  { label: 'CCI Ambert', value: 'CCI_Ambert' },
  { label: 'CCI Amiens Picardie', value: 'CCI_Amiens_Picardie' },
  { label: 'CCI Ardèche', value: 'CCI_Ardeche' },
  { label: 'CCI Ardennes', value: 'CCI_Ardennes' },
  { label: 'CCI Ariège', value: 'CCI_Ariege' },
  { label: 'CCI Arles', value: 'CCI_Arles' },
  { label: 'CCI Artois', value: 'CCI_Artois' },
  { label: 'CCI Aude', value: 'CCI_Aude' },
  { label: 'CCI Aveyron', value: 'CCI_Aveyron' },
  { label: 'CCI Avignon', value: 'CCI_Avignon' },
  { label: 'CCI Bastia et Haute Corse', value: 'CCI_Bastia_Et_Haute_Corse' },
  { label: 'CCI Bayonne Pays Basque', value: 'CCI_Bayonne_Pays_Basque' },
  { label: 'CCI Beaujolais', value: 'CCI_Beaujolais' },
  { label: 'CCI Bordeaux Gironde', value: 'CCI_Bordeaux_Gironde' },
  { label: 'CCI Bretagne', value: 'CCI_Bretagne' },
  { label: 'CCI Caen Normandie', value: 'CCI_Caen_Normandie' },
  { label: 'CCI Cantal', value: 'CCI_Cantal' },
  { label: 'CCI Chalons en Champagne', value: 'CCI_Chalons_En_Champagne' },
  { label: 'CCI Charente', value: 'CCI_Charente' },
  { label: 'CCI Charente Maritime', value: 'CCI_Charente_Maritime' },
  { label: 'CCI Cher', value: 'CCI_Cher' },
  { label: 'CCI Cholet', value: 'CCI_Cholet' },
  { label: 'CCI Corrèze', value: 'CCI_Correze' },
  { label: "CCI Cotes d'Armor", value: 'CCI_Cotes_D_Armor' },
  { label: 'CCI Creuse', value: 'CCI_Creuse' },
  { label: 'CCI des Alpes de Haute Provence', value: 'CCI_Alpes_De_Haute_Provence' },
  { label: 'CCI Deux Sèvres', value: 'CCI_Deux_Sevres' },
  { label: 'CCI Dordogne', value: 'CCI_Dordogne' },
  { label: 'CCI Drome', value: 'CCI_Drome' },
  { label: 'CCI Essonne', value: 'CCI_Essonne' },
  { label: 'CCI Eure Et Loir', value: 'CCI_Eure_Et_Loir' },
  { label: 'CCI France', value: 'CCI_France' },
  { label: 'CCI Gard', value: 'CCI_Gard' },
  { label: 'CCI Gers', value: 'CCI_Gers' },
  { label: 'CCI Grand Hainaut', value: 'CCI_Grand_Hainaut' },
  { label: 'CCI Grand Lille', value: 'CCI_Grand_Lille' },
  { label: 'CCI Grand Nancy Métropole Meurthe et Moselle', value: 'CCI_Grand_Nancy' },
  { label: 'CCI Grenoble', value: 'CCI_Grenoble' },
  { label: 'CCI Habitat', value: 'CCI_Habitat' },
  { label: 'CCI Habitat Ouest', value: 'CCI_Habitat_Ouest' },
  { label: 'CCI Habitat Sud Ouest', value: 'CCI_Habitat_Sud_Ouest' },
  { label: 'CCI Haute Loire', value: 'CCI_Haute_Loire' },
  { label: 'CCI Haute Savoie', value: 'CCI_Haute_Savoie' },
  { label: 'CCI Hautes Alpes', value: 'CCI_Hautes_Alpes' },
  { label: 'CCI Hauts De Seine', value: 'CCI_Hauts_De_Seine' },
  { label: 'CCI Hérault', value: 'CCI_Herault' },
  { label: 'CCI Ille Et Vilaine', value: 'CCI_Ille_Et_Vilaine' },
  { label: 'CCI Indre', value: 'CCI_Indre' },
  { label: 'CCI Jura', value: 'CCI_Jura' },
  { label: 'CCI La Meuse', value: 'CCI_La_Meuse' },
  { label: 'CCI Landes', value: 'CCI_Landes' },
  { label: 'CCI Le Mans et Sarthe', value: 'CCI_Le_Mans_Et_Sarthe' },
  { label: 'CCI Limoges et Haute Vienne', value: 'CCI_Limoges_Et_Haute_Vienne' },
  { label: 'CCI Littoral Hauts De France', value: 'CCI_Littoral_Hauts_De_France' },
  { label: 'CCI Loir et Cher', value: 'CCI_Loir_Et_Cher' },
  { label: 'CCI Loiret', value: 'CCI_Loiret' },
  { label: 'CCI Lot', value: 'CCI_Lot' },
  { label: 'CCI Lot et Garonne', value: 'CCI_Lot_Et_Garonne' },
  { label: 'CCI Lozère', value: 'CCI_Lozere' },
  { label: 'CCI Lyon Métropole Saint Etienne Roanne', value: 'CCI_Lyon_Metropole' },
  { label: 'CCI Maine et Loire', value: 'CCI_Maine_Et_Loire' },
  { label: 'CCI Marne en Champagne', value: 'CCI_Marne_En_Champagne' },
  { label: 'CCI Marseille Provence', value: 'CCI_Marseille_Provence' },
  { label: 'CCI Mayenne', value: 'CCI_Mayenne' },
  { label: 'CCI Métropole de Bourgogne', value: 'CCI_Metropole_De_Bourgogne' },
  { label: 'CCI Métropolitaine Bretagne Ouest', value: 'CCI_Metropolitaine_Bretagne_Ouest' },
  { label: 'CCI Meuse Haute Marne', value: 'CCI_Meuse_Haute_Marne' },
  { label: 'CCI Montauban', value: 'CCI_Montauban' },
  { label: 'CCI Montluçon', value: 'CCI_Montlucon' },
  { label: 'CCI Morbihan', value: 'CCI_Morbihan' },
  { label: 'CCI Moselle Métropole Metz', value: 'CCI_Moselle_Metropole_Metz' },
  { label: 'CCI Nantes Saint Nazaire', value: 'CCI_Nantes_Saint_Nazaire' },
  { label: "CCI Nice Côte d'Azur", value: "CCI_Nice_Cote_D'azur" },
  { label: 'CCI Nièvre', value: 'CCI_Nievre' },
  { label: 'CCI Nord Isère', value: 'CCI_Nord_Isere' },
  { label: 'CCI Oise', value: 'CCI_Oise' },
  { label: 'CCI Ouest Normandie', value: 'CCI_Ouest_Normandie' },
  { label: 'CCI Paris', value: 'CCI_Paris' },
  { label: 'CCI Pau Béarn', value: 'CCI_Pau_Bearn' },
  { label: "CCI Pays d'Arles", value: "CCI_Pays_D'arles" },
  { label: 'CCI Perpignan Pyrénées Orientales', value: 'CCI_Perpignan_Pyrenees_Orientales' },
  { label: 'CCI Portes De Normandie', value: 'CCI_Portes_De_Normandie' },
  { label: 'CCI Puy De Dôme', value: 'CCI_Puy_De_Dome' },
  { label: 'CCI Riom', value: 'CCI_Riom' },
  { label: 'CCI Roanne', value: 'CCI_Roanne' },
  { label: 'CCI Rouen Métropole', value: 'CCI_Rouen_Metropole' },
  { label: 'CCI Saint Malo', value: 'CCI_Saint_Malo' },
  { label: 'CCI Saône Doubs', value: 'CCI_Saone_Doubs' },
  { label: 'CCI Savoie', value: 'CCI_Savoie' },
  { label: 'CCI Seine Estuaire', value: 'CCI_Seine_Estuaire' },
  { label: 'CCI Seine et Marne', value: 'CCI_Seine_Et_Marne' },
  { label: 'CCI Seine Saint Denis', value: 'CCI_Seine_Saint_Denis' },
  { label: 'CCI St Luce sur Loire', value: 'CCI_St_Luce_Sur_Loire' },
  { label: 'CCI Sud Alsace Eurométropole', value: 'CCI_Sud_Alsace_Eurometropole' },
  { label: 'CCI Tarbes et Hautes Pyrénées', value: 'CCI_Tarbes_Et_Hautes_Pyrenees' },
  { label: 'CCI Tarn', value: 'CCI_Tarn' },
  { label: 'CCI Territoire de Belfort', value: 'CCI_Territoire_De_Belfort' },
  { label: 'CCI Thiers', value: 'CCI_Thiers' },
  { label: 'CCI Toulouse', value: 'CCI_Toulouse' },
  { label: 'CCI Touraine', value: 'CCI_Touraine' },
  { label: 'CCI Troyes et Aube', value: 'CCI_Troyes_Et_Aube' },
  { label: 'CCI Val de Marne', value: 'CCI_Val_De_Marne' },
  { label: "CCI Val d'Oise", value: "CCI_Val_D'oise" },
  { label: 'CCI Valence', value: 'CCI_Valence' },
  { label: 'CCI Var', value: 'CCI_Var' },
  { label: 'CCI Vaucluse', value: 'CCI_Vaucluse' },
  { label: 'CCI Vendée', value: 'CCI_Vendee' },
  { label: 'CCI Versailles Yvelines', value: 'CCI_Versailles__Yvelines' },
  { label: 'CCI Vichy', value: 'CCI_Vichy' },
  { label: 'CCI Vienne', value: 'CCI_Vienne' },
  { label: 'CCI Vosges', value: 'CCI_Vosges' },
  { label: 'CCI Yonne', value: 'CCI_Yonne' },

  // --- CCIR ---
  { label: 'CCIR Auvergne Rhône-Alpes', value: 'CCIR_Auvergne_Rhone_Alpes' },
  { label: 'CCIR Bourgogne Franche-Comté', value: 'CCIR_Bourgogne_Franche_Comte' },
  { label: 'CCIR Centre Val de Loire', value: 'CCIR_Centre_Val_De_Loire' },
  { label: 'CCIR Corse', value: 'CCIR_Corse' },
  { label: 'CCIR Grand Est', value: 'CCIR_Grand_Est' },
  { label: 'CCIR Guyane', value: 'CCIR_Guyane' },
  { label: 'CCIR Hauts de France', value: 'CCIR_Hauts_De_France' },
  { label: 'CCIR Iles de Guadeloupe', value: 'CCIR_Iles_De_Guadeloupe' },
  { label: 'CCIR La Réunion', value: 'CCIR_La_Reunion' },
  { label: 'CCIR Martinique', value: 'CCIR_Martinique' },
  { label: 'CCIR Mayotte', value: 'CCIR_Mayotte' },
  { label: 'CCIR Normandie', value: 'CCIR_Normandie' },
  { label: 'CCIR Nouvelle Aquitaine', value: 'CCIR_Nouvelle_Aquitaine' },
  { label: 'CCIR Occitanie', value: 'CCIR_Occitanie' },
  { label: 'CCIR Paris Ile-de-France', value: 'CCIR_Paris_Ile_De_France' },
  { label: 'CCIR Pays de la Loire', value: 'CCIR_Pays_De_La_Loire' },
  { label: "CCIR Provence Alpes Côte d'Azur", value: "CCIR_Provence_Alpes_Cote_D'azur" },

  // --- CCISM ---
  { label: 'CCISM Saint Martin', value: 'CCISM_Saint_Martin' },

  // --- Cegelease / CEM ---
  { label: 'Cegelease', value: 'Cegelease' },
  { label: 'CEM Saint Barthélémy', value: 'CEM_Saint_Barthelemy' },

  // --- Cetelem / CFCAL ---
  { label: 'Cetelem', value: 'CETELEM' },
  { label: 'CFCAL', value: 'CFCAL' },

  // --- CIC ---
  { label: 'CIC BANQUE PRIVEE', value: 'CIC_BANQUE_PRIVEE' },
  { label: 'CIC EST', value: 'CIC_EST' },
  { label: 'CIC ILE DE FRANCE', value: 'CIC_ILE_DE_FRANCE' },
  { label: 'CIC LYONNAISE DE BANQUE', value: 'CIC_LYONNAISE_DE_BANQUE' },
  { label: 'CIC NORD OUEST', value: 'CIC_NORD_OUEST' },
  { label: 'CIC OUEST', value: 'CIC_OUEST' },
  { label: 'CIC SUD OUEST', value: 'CIC_SUD_OUEST' },

  // --- Cofinoga / CREATIS ---
  { label: 'Cofinoga', value: 'Cofinoga' },
  { label: 'CREATIS', value: 'Creatis' },

  // --- Crédit Agricole ---
  { label: 'Crédit Agricole Alpes Provence', value: 'CA_Alpes_Provence' },
  { label: 'Crédit Agricole Alsace Vosges', value: 'CA_Alsace_Vosges' },
  { label: 'Crédit Agricole Atlantique Vendée', value: 'CA_Atlantique_Vendee' },
  { label: 'Crédit Agricole Brie Picardie', value: 'CA_Brie_Picardie' },
  { label: 'Crédit Agricole Centre Est', value: 'CA_Centre_Est' },
  { label: 'Crédit Agricole Centre France', value: 'CA_Centre_France' },
  { label: 'Crédit Agricole Centre Loire', value: 'CA_Centre_Loire' },
  { label: 'Crédit Agricole Centre Ouest', value: 'CA_Centre_Ouest' },
  { label: 'Crédit Agricole Champagne-Bourgogne', value: 'CA_Champagne_Bourgogne' },
  { label: 'Crédit Agricole Charente Périgord', value: 'CA_Charente_Perigord' },
  { label: 'Crédit Agricole Charente-Maritime Deux-Sèvres', value: 'CA_Charente_Maritime' },
  { label: 'Crédit Agricole Consumer Finance', value: 'CA_consumer_finance' },
  { label: "Crédit Agricole d'Aquitaine", value: 'CA_Aquitaine' },
  { label: 'Crédit Agricole de Franche-Comté', value: 'CA_Franche_Comte' },
  { label: 'Crédit Agricole de Guadeloupe', value: 'CA_Guadeloupe' },
  { label: 'Crédit Agricole de la Corse', value: 'CA_Corse' },
  { label: 'Crédit Agricole de la Réunion', value: 'CA_Reunion' },
  { label: "Crédit Agricole de l'Anjou et du Maine", value: 'CA_Anjou_Maine' },
  { label: 'Crédit Agricole de Loire Haute-Loire', value: 'CA_Loire_Haute_Loire' },
  { label: 'Crédit Agricole de Lorraine', value: 'CA_Lorraine' },
  { label: 'Crédit Agricole de Martinique-Guyane', value: 'CA_Martinique_Guyane' },
  { label: 'Crédit Agricole de Normandie', value: 'CA_Normandie' },
  { label: "Crédit Agricole de Paris et d'Ile-de-France", value: 'CA_Paris' },
  { label: 'Crédit Agricole de Pyrénées Gascogne', value: 'CA_Pyrenees_Gascogne' },
  { label: 'Crédit Agricole de Val de France', value: 'CA_Val_de_France' },
  { label: "Crédit Agricole des Côtes d'Armor", value: 'CA_Cotes_Armor' },
  { label: 'Crédit Agricole des Savoie', value: 'CA_Savoie' },
  { label: "Crédit Agricole d'Ille et Vilaine", value: 'CA_Ille_et_Vilaine' },
  { label: 'Crédit Agricole du Finistère', value: 'CA_Finistere' },
  { label: 'Crédit Agricole du Languedoc', value: 'CA_Languedoc' },
  { label: 'Crédit Agricole du Morbihan', value: 'CA_Morbihan' },
  { label: 'Crédit Agricole Nord de France', value: 'CA_Nord_de_France' },
  { label: 'Crédit Agricole Nord Est', value: 'CA_Nord_Est' },
  { label: 'Crédit Agricole Nord Midi Pyrénées', value: 'CA_Nord_Midi_Pyrenees' },
  { label: 'Crédit Agricole Normandie-Seine', value: 'CA_Normandie_Seine' },
  { label: "Crédit Agricole Provence Côte d'Azur", value: 'CA_Provence' },
  { label: 'Crédit Agricole Sud Méditerranée', value: 'CA_Sud_Mediterranee' },
  { label: 'Crédit Agricole Sud Rhône-Alpes', value: 'CA_Sud_Rhone_Alpes' },
  { label: 'Crédit Agricole Toulouse 31', value: 'CA_Toulouse' },
  { label: 'Crédit Agricole Touraine Poitou', value: 'CA_Touraine_Poitou' },

  // --- Crédit Coopératif ---
  { label: 'Crédit Coopératif', value: 'Credit_Cooperatif' },

  // --- Crédit Foncier ---
  { label: 'Crédit Foncier', value: 'Credit_Foncier' },

  // --- Crédit Immobilier ---
  { label: 'Crédit Immobilier De France Développement', value: 'Credit_Immobilier_De_France_Developpement' },

  // --- Crédit Maritime ---
  { label: 'Crédit Maritime Grand Ouest', value: 'Credit_Maritime_Grand_Ouest' },
  { label: 'Crédit Maritime Méditerranée', value: 'Credit_Maritime_Mediterranee' },

  // --- Crédit Mutuel ---
  { label: 'Crédit Mutuel', value: 'credit_mut' },
  { label: 'Crédit Mutuel Alliance Fédérale', value: 'credit_mut_Alliance_federale' },
  { label: 'Crédit Mutuel Antilles-Guyane', value: 'credit_mut_Antilles_Guyane' },
  { label: 'Crédit Mutuel ARKEA', value: 'credit_mut_ARKEA' },
  { label: 'Crédit Mutuel de Bretagne', value: 'credit_mut_Bretagne' },
  { label: 'Crédit Mutuel du Sud-Ouest', value: 'credit_mut_Sud_Ouest' },
  { label: 'Crédit Mutuel Maine-Anjou Basse-Normandie', value: 'credit_mut_Maine' },
  { label: 'Crédit Mutuel Nord Europe', value: 'credit_mut_Nord_Europe' },
  { label: 'Crédit Mutuel Océan', value: 'credit_mut_ocean' },

  // --- CréditLift ---
  { label: 'CréditLift', value: 'Credit_Lift' },

  // --- D ---
  { label: 'Direct Lease Group', value: 'Direct_Lease_Group' },
  { label: 'Domofinance', value: 'Domofinance' },

  // --- F ---
  { label: 'Fortis Lease', value: 'Fortis_Lease' },
  { label: 'Fortis Lease Immobilier France', value: 'Fortis_Lease_Immobilier' },
  { label: 'Fortuneo Banque', value: 'Fortuneo_Banque' },
  { label: 'Franfinance', value: 'franfinance' },

  // --- G ---
  { label: 'Groupama Banque', value: 'groupama' },

  // --- H ---
  { label: 'Hello Bank', value: 'Hello_Bank' },
  { label: 'HSBC Continental Europe (contrat groupe)', value: 'HSBC' },
  { label: 'HSBC Continental Europe (contrat Solution Emprunteur)', value: 'HSBC_Solution_Emprunteur' },

  // --- I ---
  { label: 'ING Direct', value: 'ing_direct' },

  // --- L ---
  { label: 'La Banque Postale', value: 'Banque_Postale' },
  { label: 'LCL', value: 'LCL' },
  { label: 'LCL Caci - LCL Banque Privée', value: 'LCL_Banque_Privee' },
  { label: 'Louvre Banque Privée', value: 'BQ_PRIV_EUROPPEENNE' },

  // --- M ---
  { label: 'Milleis Banque', value: 'milleis_banque' },
  { label: 'Monabanq', value: 'Monabanq' },
  { label: 'My Money Bank', value: 'My_Money_Bank' },

  // --- O ---
  { label: 'Océor Lease', value: 'Oceor_Lease' },
  { label: 'Orange Bank', value: 'Orange_Bank' },

  // --- S ---
  { label: 'SBE Banque Populaire', value: 'SBE_Banque_Populaire' },
  { label: 'SG Auvergne-Rhône-Alpes', value: 'SG_auvergne_rhone_alpes' },
  { label: 'SG Courtois', value: 'SG_courtois' },
  { label: 'SG Crédit du Nord', value: 'SG_credit_du_nord' },
  { label: 'SG Grand Est', value: 'SG_grand_est' },
  { label: 'SG Grand Ouest', value: 'SG_grand_ouest' },
  { label: 'SG Laydernier', value: 'SG_laydernier' },
  { label: 'SG SMC', value: 'SG_SMC' },
  { label: 'SG Société Générale', value: 'SG_societe_generale' },
  { label: 'SG Sud Ouest', value: 'SG_sud_ouest' },
  { label: 'SG Tarneaud', value: 'SG_tarneaud' },
  { label: 'Siemens Financial Services', value: 'Siemens_Financial_Services' },
  { label: 'Socram Banque', value: 'Socram_Banque' },
  { label: 'Socrif Sofiap', value: 'SOCRIF_SOFIAP' },
  { label: 'SOFIDER Océan Indien', value: 'SOFIDER_Ocean_Indien' },
  { label: 'SOFINCO', value: 'sofinco' },
  { label: 'Sogelease Antilles', value: 'Sogelease_Antilles' },
  { label: 'Sogelease France', value: 'Sogelease_France' },
  { label: 'Star Lease', value: 'Star_Lease' },

  // --- Y ---
  { label: 'Younited Credit', value: 'younited_credit' },
];

// Export trié alphabétiquement par label
export const TOUTES_LES_BANQUES = [...BANQUES_LIST].sort((a, b) =>
  a.label.localeCompare(b.label, 'fr')
);

// =============================================================================
// RÉSOLUTION BANQUE RÉGIONALE PAR CODE POSTAL
// Permet de trouver la caisse régionale d'une grande famille bancaire
// à partir du code postal du client.
// =============================================================================

export interface BankRangeEntry {
  value: string;   // Code April (= valeur dans BANQUES_LIST)
  label: string;
  ranges: [number, number][];
  departments?: string[];
}

export interface BankFamily {
  familyName: string;
  /** Mots-clés normalisés pour identifier la famille depuis une saisie libre */
  keywords: string[];
  ranges: BankRangeEntry[];
}

// ---------------------------------------------------------------------------
// Crédit Agricole
// ---------------------------------------------------------------------------
const CA_RANGES: BankRangeEntry[] = [
  { value: 'CA_Alpes_Provence',     label: 'Crédit Agricole Alpes Provence',             ranges: [[5000,5800],[13000,13999],[84000,84850]] },
  { value: 'CA_Alsace_Vosges',      label: 'Crédit Agricole Alsace Vosges',              ranges: [[67000,67999],[68000,68999],[88000,88999]] },
  { value: 'CA_Anjou_Maine',        label: "Crédit Agricole de l'Anjou et du Maine",     ranges: [[49000,49999],[53000,53999],[72000,72999]] },
  { value: 'CA_Aquitaine',          label: "Crédit Agricole d'Aquitaine",                ranges: [[33000,33999],[40000,40999],[47000,47999]] },
  { value: 'CA_Atlantique_Vendee',  label: 'Crédit Agricole Atlantique Vendée',          ranges: [[44000,44999],[85000,85999]] },
  { value: 'CA_Brie_Picardie',      label: 'Crédit Agricole Brie Picardie',              ranges: [[60000,60999],[77000,77999],[80000,80999]] },
  { value: 'CA_Centre_Est',         label: 'Crédit Agricole Centre Est',                 ranges: [[1000,1999],[69000,69999],[71000,71999]] },
  { value: 'CA_Centre_France',      label: 'Crédit Agricole Centre France',              ranges: [[3000,3999],[15000,15999],[19000,19999],[23000,23999],[63000,63999]] },
  { value: 'CA_Centre_Loire',       label: 'Crédit Agricole Centre Loire',               ranges: [[18000,18999],[45000,45999],[58000,58999]] },
  { value: 'CA_Centre_Ouest',       label: 'Crédit Agricole Centre Ouest',               ranges: [[36000,36999],[87000,87999]] },
  { value: 'CA_Champagne_Bourgogne',label: 'Crédit Agricole Champagne-Bourgogne',        ranges: [[10000,10999],[21000,21999],[52000,52999],[89000,89999]] },
  { value: 'CA_Charente_Maritime',  label: 'Crédit Agricole Charente-Maritime Deux-Sèvres', ranges: [[17000,17999],[79000,79999]] },
  { value: 'CA_Charente_Perigord',  label: 'Crédit Agricole Charente Périgord',          ranges: [[16000,16999],[24000,24999]] },
  { value: 'CA_Corse',              label: 'Crédit Agricole de la Corse',                ranges: [[20000,20620]] },
  { value: 'CA_Cotes_Armor',        label: "Crédit Agricole des Côtes d'Armor",         ranges: [[22000,22999]] },
  { value: 'CA_Savoie',             label: 'Crédit Agricole des Savoie',                 ranges: [[73000,73999],[74000,74999]] },
  { value: 'CA_Finistere',          label: 'Crédit Agricole du Finistère',               ranges: [[29000,29999]] },
  { value: 'CA_Franche_Comte',      label: 'Crédit Agricole de Franche-Comté',           ranges: [[25000,25999],[39000,39999],[70000,70999],[90000,90999]] },
  { value: 'CA_Guadeloupe',         label: 'Crédit Agricole de Guadeloupe',              ranges: [[97100,97199]] },
  { value: 'CA_Ille_et_Vilaine',    label: "Crédit Agricole d'Ille et Vilaine",         ranges: [[35000,35999]] },
  { value: 'CA_Languedoc',          label: 'Crédit Agricole du Languedoc',               ranges: [[11000,11999],[30000,30999],[34000,34999],[48000,48999]] },
  { value: 'CA_Loire_Haute_Loire',  label: 'Crédit Agricole de Loire Haute-Loire',      ranges: [[42000,42999],[43000,43999]] },
  { value: 'CA_Lorraine',           label: 'Crédit Agricole de Lorraine',                ranges: [[54000,54999],[55000,55999],[57000,57999]] },
  { value: 'CA_Martinique_Guyane',  label: 'Crédit Agricole de Martinique-Guyane',      ranges: [[97200,97299],[97300,97399]] },
  { value: 'CA_Morbihan',           label: 'Crédit Agricole du Morbihan',                ranges: [[56000,56999]] },
  { value: 'CA_Nord_de_France',     label: 'Crédit Agricole Nord de France',             ranges: [[59000,59999],[62000,62999]] },
  { value: 'CA_Nord_Est',           label: 'Crédit Agricole Nord Est',                   ranges: [[2000,2999],[8000,8999],[51000,51999]] },
  { value: 'CA_Nord_Midi_Pyrenees', label: 'Crédit Agricole Nord Midi Pyrénées',        ranges: [[12000,12999],[46000,46999],[81000,81999],[82000,82999]] },
  { value: 'CA_Normandie',          label: 'Crédit Agricole de Normandie',               ranges: [[14000,14999],[50000,50999],[61000,61999]] },
  { value: 'CA_Normandie_Seine',    label: 'Crédit Agricole Normandie-Seine',            ranges: [[27000,27999],[76000,76999]] },
  { value: 'CA_Paris',              label: "Crédit Agricole de Paris et d'Ile-de-France", ranges: [[75000,75999],[78000,78999],[91000,91999],[92000,92999],[93000,93999],[94000,94999],[95000,95999]] },
  { value: 'CA_Provence',           label: "Crédit Agricole Provence Côte d'Azur",      ranges: [[4000,4999],[6000,6999],[83000,83999]] },
  { value: 'CA_Pyrenees_Gascogne',  label: 'Crédit Agricole de Pyrénées Gascogne',      ranges: [[32000,32999],[64000,64999],[65000,65999]] },
  { value: 'CA_Reunion',            label: 'Crédit Agricole de la Réunion',              ranges: [[97400,97499],[97600,97699]] },
  { value: 'CA_Sud_Mediterranee',   label: 'Crédit Agricole Sud Méditerranée',           ranges: [[9000,9999],[66000,66999]] },
  { value: 'CA_Sud_Rhone_Alpes',    label: 'Crédit Agricole Sud Rhône-Alpes',            ranges: [[7000,7999],[26000,26999],[38000,38999]] },
  { value: 'CA_Toulouse',           label: 'Crédit Agricole Toulouse 31',                ranges: [[31000,31999]] },
  { value: 'CA_Touraine_Poitou',    label: 'Crédit Agricole Touraine Poitou',            ranges: [[37000,37999],[86000,86999]] },
  { value: 'CA_Val_de_France',      label: 'Crédit Agricole de Val de France',           ranges: [[28000,28999],[41000,41999]] },
];

// ---------------------------------------------------------------------------
// Caisse d'Épargne
// ---------------------------------------------------------------------------
const CE_RANGES: BankRangeEntry[] = [
  { value: 'Caisse_Epargne_CEPAC',          label: "Caisse d'Épargne CEPAC",                       ranges: [[4000,4999],[5000,5800],[13000,13999],[20000,20620],[84000,84850],[97100,97699]] },
  { value: 'Caisse_Epargne_Aquitaine',       label: "Caisse d'Épargne Aquitaine Poitou Charentes",  ranges: [[16000,16999],[17000,17999],[24000,24999],[33000,33999],[40000,40999],[47000,47999],[64000,64999],[79000,79999],[86000,86999]] },
  { value: 'Caisse_Epargne_Auvergne',        label: "Caisse d'Épargne d'Auvergne et Limousin",      ranges: [[3000,3999],[15000,15999],[19000,19999],[23000,23999],[43000,43999],[63000,63999],[87000,87999]] },
  { value: 'Caisse_Epargne_Bourgogne',       label: "Caisse d'Épargne Bourgogne Franche-Comté",     ranges: [[21000,21999],[25000,25999],[39000,39999],[58000,58999],[70000,70999],[71000,71999],[89000,89999],[90000,90999]] },
  { value: 'Caisse_Epargne_Bretagne',        label: "Caisse d'Épargne Bretagne Pays de la Loire",   ranges: [[22000,22999],[29000,29999],[35000,35999],[44000,44999],[49000,49999],[53000,53999],[56000,56999],[72000,72999],[85000,85999]] },
  { value: 'Caisse_Epargne_Cote_Azur',       label: "Caisse d'Épargne Côte d'Azur",                ranges: [[6000,6999],[83000,83999]] },
  { value: 'Caisse_Epargne_Grand_Est',       label: "Caisse d'Épargne Grand Est Europe",            ranges: [[8000,8999],[10000,10999],[51000,51999],[52000,52999],[54000,54999],[55000,55999],[57000,57999],[67000,67999],[68000,68999],[88000,88999]] },
  { value: 'Caisse_Epargne_Hauts_de_France', label: "Caisse d'Épargne Hauts de France",             ranges: [[2000,2999],[59000,59999],[60000,60999],[62000,62999],[80000,80999]] },
  { value: 'Caisse_Epargne_Ile_de_France',   label: "Caisse d'Épargne Île-de-France",               ranges: [[75000,75999],[77000,77999],[78000,78999],[91000,91999],[92000,92999],[93000,93999],[94000,94999],[95000,95999]] },
  { value: 'Caisse_Epargne_Languedoc',       label: "Caisse d'Épargne Languedoc Roussillon",        ranges: [[11000,11999],[30000,30999],[34000,34999],[48000,48999],[66000,66999]] },
  { value: 'Caisse_Epargne_Loire_Centre',    label: "Caisse d'Épargne Loire Centre",                ranges: [[18000,18999],[28000,28999],[36000,37999],[41000,41999],[45000,45999]] },
  { value: 'Caisse_Epargne_Loire_Drome',     label: "Caisse d'Épargne Loire Drôme Ardèche",         ranges: [[7000,7999],[26000,26999],[42000,42999]] },
  { value: 'Caisse_Epargne_Midi_Pyrenees',   label: "Caisse d'Épargne Midi Pyrénées",               ranges: [[9000,9999],[12000,12999],[31000,31999],[32000,32999],[46000,46999],[65000,65999],[81000,81999],[82000,82999]] },
  { value: 'Caisse_Epargne_Normandie',       label: "Caisse d'Épargne Normandie",                   ranges: [[14000,14999],[27000,27999],[50000,50999],[61000,61999],[76000,76999]] },
  { value: 'Caisse_Epargne_Rhone_Alpes',     label: "Caisse d'Épargne Rhône-Alpes",                 ranges: [[1000,1999],[38000,38999],[69000,69999],[73000,73999],[74000,74999]] },
];

// ---------------------------------------------------------------------------
// Banque Populaire
// ---------------------------------------------------------------------------
const BP_RANGES: BankRangeEntry[] = [
  { value: 'banque_pop_alsace_lorraine_champagne', label: 'Banque Populaire Alsace Lorraine et Champagne', ranges: [[10000,10999],[51000,52999],[54000,55999],[57000,57999],[67000,68999],[88000,88999]] },
  { value: 'banque_pop_AURA',                      label: 'Banque Populaire AURA',                          ranges: [[1000,1999],[3000,3999],[4000,5999],[7000,7999],[15000,15999],[26000,26999],[38000,38999],[42000,43999],[63000,63999],[69000,69999],[73000,74999]] },
  { value: 'banque_pop_bourgogne_franche_comte',   label: 'Banque Populaire Bourgogne Franche-Comté',       ranges: [[21000,21999],[25000,25999],[39000,39999],[58000,58999],[70000,71999],[89000,89999],[90000,90999]] },
  { value: 'BRED',                                 label: 'BRED Banque Populaire',                          ranges: [[14000,14999],[75000,75999],[76000,77999],[92000,95999],[97100,97499],[97600,97699]] },
  { value: 'banque_pop_Aquitaine_centre_Atlantique',label: 'Banque Populaire Aquitaine Centre Atlantique',  ranges: [[16000,17999],[19000,19999],[23000,23999],[24000,24999],[33000,33999],[40000,40999],[47000,47999],[64000,64999],[79000,79999],[86000,87999]] },
  { value: 'banque_pop_GRAND_OUEST',               label: 'Banque Populaire Grand Ouest',                   ranges: [[22000,22999],[29000,29999],[35000,35999],[44000,44999],[49000,50999],[53000,53999],[56000,56999],[61000,61999],[72000,72999],[85000,85999]] },
  { value: 'banque_pop_mediterranee',              label: 'Banque Populaire Méditerranée',                  ranges: [[6000,6999],[13000,13999],[20000,20620],[26000,26999],[30000,30999],[34000,34999],[83000,84999]] },
  { value: 'banque_pop_Du_nord',                   label: 'Banque Populaire du Nord',                       ranges: [[2000,2999],[8000,8999],[59000,59999],[62000,62999],[80000,80999]] },
  { value: 'banque_pop_OCCITANE',                  label: 'Banque Populaire Occitane',                      ranges: [[9000,9999],[12000,12999],[31000,31999],[32000,32999],[46000,46999],[65000,65999],[81000,82999]] },
  { value: 'banque_pop_RIVES_DE_PARIS',            label: 'Banque Populaire Rives de Paris',                ranges: [[27000,27999],[60000,60999],[75000,75999],[78000,78999],[91000,91999],[92000,95999]] },
  { value: 'banque_pop_SUD',                       label: 'Banque Populaire du Sud',                        ranges: [[9000,9999],[11000,11999],[48000,48999],[66000,66999]] },
  { value: 'banque_pop_VAL_DE_France',             label: 'Banque Populaire Val de France',                 ranges: [[18000,18999],[28000,28999],[36000,37999],[41000,41999],[45000,45999]] },
];

// ---------------------------------------------------------------------------
// Crédit Mutuel
// ---------------------------------------------------------------------------
const CM_RANGES: BankRangeEntry[] = [
  { value: 'credit_mut_Bretagne',           label: 'Crédit Mutuel de Bretagne',                   ranges: [[22000,22999],[29000,29999],[35000,35999],[56000,56999]], departments: ['22','29','35','56'] },
  { value: 'credit_mut_Maine',              label: 'Crédit Mutuel Maine-Anjou Basse-Normandie',    ranges: [[50000,50999],[53000,53999],[61000,61999],[72000,72999]], departments: ['50','53','61','72'] },
  { value: 'credit_mut_Nord_Europe',        label: 'Crédit Mutuel Nord Europe',                    ranges: [[2000,2999],[8000,8999],[51000,51999],[59000,59999],[62000,62999]], departments: ['02','08','51','59','62'] },
  { value: 'credit_mut_ocean',              label: 'Crédit Mutuel Océan',                          ranges: [[17000,17999],[79000,79999],[85000,85999]], departments: ['17','79','85'] },
  { value: 'credit_mut_Sud_Ouest',          label: 'Crédit Mutuel du Sud-Ouest',                   ranges: [[24000,24999],[33000,33999],[40000,40999],[47000,47999]], departments: ['24','33','40','47'] },
  { value: 'credit_mut_Antilles_Guyane',    label: 'Crédit Mutuel Antilles-Guyane',                ranges: [[97100,97399]], departments: ['971','972','973'] },
  { value: 'credit_mut_ARKEA',              label: 'Crédit Mutuel ARKEA',                          ranges: [[3000,3999],[19000,19999],[23000,23999],[87000,87999]], departments: ['03','19','23','87'] },
  {
    value: 'credit_mut_Alliance_federale',
    label: 'Crédit Mutuel Alliance Fédérale',
    ranges: [[1000,95999]],
    departments: [
      '01','06','07','13','14','15','26','31','38','42','43','44','46','49',
      '54','55','57','63','67','68','69','73','74','75','77','78','81','82',
      '83','88','91','92','93','94','95','2A','2B'
    ]
  },
];

// ---------------------------------------------------------------------------
// CIC
// ---------------------------------------------------------------------------
const CIC_RANGES: BankRangeEntry[] = [
  { value: 'CIC_EST',              label: 'CIC Est',                ranges: [[52000,52999],[54000,55999],[57000,57999],[67000,68999],[88000,88999],[90000,90999]] },
  { value: 'CIC_OUEST',           label: 'CIC Ouest',              ranges: [[22000,22999],[29000,29999],[35000,35999],[44000,44999],[49000,49999],[56000,56999],[85000,85999]] },
  { value: 'CIC_NORD_OUEST',      label: 'CIC Nord Ouest',         ranges: [[14000,14999],[50000,50999],[59000,59999],[60000,60999],[61000,61999],[62000,62999],[76000,76999],[80000,80999]] },
  { value: 'CIC_SUD_OUEST',       label: 'CIC Sud Ouest',          ranges: [[24000,24999],[31000,32999],[33000,33999],[40000,40999],[47000,47999],[64000,65999]] },
  { value: 'CIC_LYONNAISE_DE_BANQUE', label: 'CIC Lyonnaise de Banque', ranges: [[1000,1999],[7000,7999],[26000,26999],[38000,38999],[42000,42999],[69000,69999],[71000,71999],[73000,74999]] },
  { value: 'CIC_ILE_DE_FRANCE',   label: 'CIC Ile de France',      ranges: [[75000,75999],[77000,77999],[78000,78999],[91000,91999],[92000,92999],[93000,93999],[94000,94999],[95000,95999]] },
  // CIC Iberbanco : couverture nationale (catch-all, s'applique si aucun autre ne matche)
  { value: 'CIC_BANQUE_PRIVEE',   label: 'CIC Banque Privée',      ranges: [[0,99999]] },
];

// ---------------------------------------------------------------------------
// Familles regroupées
// ---------------------------------------------------------------------------
export const BANK_FAMILIES: BankFamily[] = [
  { familyName: 'Crédit Agricole',  keywords: ['credit agricole', 'crédit agricole'],  ranges: CA_RANGES },
  { familyName: "Caisse d'Épargne", keywords: ["caisse d'epargne", "caisse d epargne", "caisse epargne"], ranges: CE_RANGES },
  { familyName: 'Banque Populaire', keywords: ['banque populaire'],                    ranges: BP_RANGES },
  { familyName: 'Crédit Mutuel',    keywords: ['credit mutuel', 'crédit mutuel'],       ranges: CM_RANGES },
  { familyName: 'CIC',             keywords: ['cic'],                                 ranges: CIC_RANGES },
];

// ---------------------------------------------------------------------------
// Fonction de résolution
// ---------------------------------------------------------------------------

function _normalizeStr(s: string): string {
  return s
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function _postalInt(cp: string): number | null {
  const cleaned = cp.replace(/\D/g, '');
  if (cleaned.length === 5) return parseInt(cleaned, 10);
  if (cleaned.length === 4) return parseInt(cleaned, 10) * 10;
  return null;
}

function _departmentFromPostalCode(cp: string): string | null {
  const cleaned = cp.replace(/\D/g, '');
  if (cleaned.length < 4) return null;

  const normalized = cleaned.length === 4 ? `0${cleaned}` : cleaned.slice(0, 5);
  if (normalized.startsWith('97') || normalized.startsWith('98')) {
    return normalized.slice(0, 3);
  }

  const postal = parseInt(normalized, 10);
  if (postal >= 20000 && postal <= 20999) {
    return postal < 20200 ? '2A' : '2B';
  }

  return normalized.slice(0, 2);
}

function _inRanges(postal: number, ranges: [number, number][]): boolean {
  return ranges.some(([lo, hi]) => postal >= lo && postal <= hi);
}

function _entryMatchesPostal(entry: BankRangeEntry, postal: number, department: string | null): boolean {
  if (entry.departments?.length) {
    return department !== null && entry.departments.includes(department);
  }

  return _inRanges(postal, entry.ranges);
}

/**
 * Retourne toutes les banques régionales qui correspondent à la famille
 * bancaire identifiée dans `bankName` et au `postalCode` fourni.
 */
export function resolveBanksByNameAndPostalCode(
  bankName: string,
  postalCode: string
): { label: string; value: string }[] {
  if (!bankName || !postalCode) return [];

  const normName = _normalizeStr(bankName);
  const postalInt = _postalInt(postalCode);
  if (postalInt === null) return [];
  const department = _departmentFromPostalCode(postalCode);

  // Identifier la famille
  const family = BANK_FAMILIES.find(f =>
    f.keywords.some(kw => normName.includes(_normalizeStr(kw)))
  );
  if (!family) return [];

  // Trouver les régions correspondantes (sans doublons sur value)
  const seen = new Set<string>();
  const results: { label: string; value: string }[] = [];
  for (const entry of family.ranges) {
    if (seen.has(entry.value)) continue;
    if (_entryMatchesPostal(entry, postalInt, department)) {
      results.push({ label: entry.label, value: entry.value });
      seen.add(entry.value);
    }
  }
  return results;
}
